module.exports = __webpack_public_path__ + "static/media/BSCDEFI.e272b8dd.svg";